import { Link } from 'react-router-dom';

import Logo from 'assets/images/logo.png';
import { NAV_ROUTES } from 'constants/routes';

import { Line, Container, LogoContainer, NavLink } from './styles';

export const SideMenu = () => (
  <Container>
    <LogoContainer>
      <Link to="/">
        <img src={Logo} />
      </Link>
    </LogoContainer>

    <ul>
      {NAV_ROUTES.map((route) => (
        <li key={`nav-link-${route.title}`}>
          <NavLink to={route.to}>
            <Line />
            <h3>{route.title}</h3>
          </NavLink>
        </li>
      ))}
    </ul>
  </Container>
);
